<template>
  <div>
    <!--    기본정보-->
    <field-select-module v-model="form.stdInfo" :options="[
        { type: 'date', label: '점검일'},
        { type: 'text', label: '점검장소'},
        { type: 'disaster', label: '재해형태'}
      ]" :board="this.board" :is-print="isPrint"/>

    <!--    점검대상-->
<!--    <vs-row class="mt-6">-->
<!--      <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">-->
<!--        <h5>-->
<!--          <i class="dot"></i> 점검대상-->
<!--        </h5>-->
<!--      </vs-col>-->
<!--    </vs-row>-->

<!--    <div class="gap-x-6 gap-y-4 mt-4">-->
<!--      <span v-if="isPrint"> {{form.inspectionTitle}} </span>-->
<!--      <div class="ml-group-checkBox flex flex-wrap w-full flex-1" v-else>-->
<!--        <vs-checkbox-->
<!--          class="mr-1 mb-2"-->
<!--          :readonly="board.readonly">-->
<!--          {{form.inspectionTitle}}-->
<!--        </vs-checkbox>-->
<!--      </div>-->
<!--    </div>-->


    <table-inspect
      class="mt-5"
      :is-print="isPrint"
      :is-readonly="board.readonly"
      :is-show-title="true"
      :title="form.inspectionTitle"
      :list="form.inspectList"
      @update-list-check="updateListCheck"
    />


    <!--    사진대지-->
    <PhotoUploadGridModule
      v-model="form.photoList"
      :is-print="isPrint"
      :readonly="board.readonly"
      section-title="사진대지"
      placeholder="신축현장 점검"
    />

    <!--    파일첨부-->
    <file-upload-module
      id="fileList"
      class="w-full mt-4"
      v-model="form.fileList"
      :is-print="isPrint"
      :readonly="board.readonly"
    ></file-upload-module>

  </div>
</template>

<script>
import PopupPlanProject from '@/views/project/popup/PopupPlanProject'
import DateSelector from '@/components/selector/DateSelector'
import PopupProjectSetting from '@/views/project/PopupProjectSetting'
import MemberSelector from '@/components/selector/MemberSelector'
import CompanySelector from '@/components/selector/CompanySelector'
import FileUploader from '@/components/FileUploader'
import FileUploadModule from '@/views/modules/FileUploadModule'
import TableInspect from '@/components/TableInspect'
import TableEquipment from '@/components/TableEquipment'
import DisasterClassSelector from '@/components/selector/DisasterClassSelector'
import FieldSelectModule from '@/views/modules/FieldSelectModule'
import PhotoUploadGridModule from '@/views/modules/PhotoUploadGridModule'

export default {
  components: {
    FileUploadModule,
    TableInspect,
    TableEquipment,
    DisasterClassSelector,
    FileUploader,
    CompanySelector,
    MemberSelector,
    PopupProjectSetting,
    DateSelector,
    PopupPlanProject,
    FieldSelectModule,
    PhotoUploadGridModule
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler (value) {
        const keys = Object.keys(this.form)
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key]
          }
        }

        this.form.inspectionTitle = this.inspectionTitle
        if (!this.form || !this.form.inspectList || this.form.inspectList.length === 0) {
          this.form.inspectList = this.inspectTable
        }
      }
    },
    form: {
      immediate: true,
      deep: true,
      handler (value) {
        this.$emit('input', value)
      }
    }
  },
  data () {
    return {

      inspectionTitle:'밀폐공간 작업',
      form: {
        inspectionTitle:'밀폐공간 작업',
        stdInfo: { },
        photoList: [],
        fileList: [],
        equipmentList: [],
        inspectList: []
      },
    }
  },
  computed: {
    inspectTable () {
      return [
        {
          id: 1,
          label: '질식위험공간에 출입 전 산소 및 유해가스 농도를 측정하는가?\n' +
            '※ 적정공기 : 산소 18%~23.5%, 탄산가스 1.5% 미만, 일산화탄소 30ppm미만, 황화수소 10ppm 미만',
          is_checked: ''
        },
        {
          id: 2,
          label: '적정공기 상태가 유지되도록 작업 전･작업 중 지속적으로 환기하는가?',
          is_checked: ''
        },
        {
          id: 3,
          label: '구조작업 시 공기호흡기 등 보호 장비를 착용할 수 있도록 작업장 주변에 비치 하는가?',
          is_checked: ''
        },
        {
          id: 4,
          label: '종사자가 작업하는 밀폐공간 작업이 존재하는가?',
          is_checked: ''
        },
        {
          id: 5,
          label: '밀폐공간 유해가스, 산소결핍, 화재･폭발 위험 등에 대하여 사전 조사를 하는가?',
          is_checked: ''
        },
        {
          id: 6,
          label: '밀폐공간 작업 프로그램을 수립하여 시행 하는가?',
          is_checked: ''
        },
        {
          id: 7,
          label: '작업 시작 전 산소 및 유해가스농도 측정에 관한 사항, 응급조치요령, 환기설비 가동 등 안전작업방법, 보호구 사용 등에 대한 사항을 작업종사자에게 교육 등을 통해 알리는가?',
          is_checked: ''
        },
        {
          id: 8,
          label: '산소농도, 유해가스측정기, 환기팬, 공기호흡기와 송기마스크 등 호흡용보호구, 안전대, 구명밧줄, 안전장비 등 사전에 필요한 장비의 준비･점검･사용법을 숙지하는가?',
          is_checked: ''
        },
        {
          id: 9,
          label: '긴급 상황 대비 무전기 등 통신장비를 구비하여 연락체계를 갖추고 있는가?',
          is_checked: ''
        },
        {
          id: 10,
          label: '감시인은 작업자가 내부에 있을 때 항상 정위치에 있으며, 필요한 보호장비와 구조장비를 갖추고 있는가?',
          is_checked: ''
        },
        {
          id: 11,
          label: '관계 종사자가 아닌 사람의 출입을 금지하고, 그 내용을 보기 쉬운 장소에 게시하고 있는가?',
          is_checked: ''
        },
        {
          id: 12,
          label: '밀폐공간 작업장소에 종사자를 입장 및 퇴장시킬 때마다 인원을 점검 하는가?',
          is_checked: ''
        },
        {
          id: 13,
          label: '밀폐공간 작업을 위해 허가자에게 밀폐공간 작업 허가를 받고 있는가?',
          is_checked: ''
        },
        {
          id: 14,
          label: '관리감독자가 밀폐공간 안전보건조치 사항을 지휘, 점검 등의 업무를 하고 있는가?',
          is_checked: ''
        },
      ]
    },
  },
  methods : {
    updateList (list) {
      this.form.equipmentList = list
    },
    updateListCheck (indexRows, text) {
      this.form.inspectList[indexRows].is_checked = text
    },
  }
}
</script>

<style scoped lang="scss">
$border: 1px solid #cdcdcd;
.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
}
.mt-component-form {
  margin-top: 15px;
}

/* uploaded File */
.h-upload {
  height: 470px;
}
.upload-content {
  border: $border;
  &:last-child {
    border-left: none;
  }
  &__title {
    height: 54px;
    line-height: 54px;
    text-align: center;
    background: #fafafa;
    border-bottom: $border;
  }
  &__input {
    height: 54px;
    background: #f9f9f9;
    border-top: $border;
    padding: 5px 15px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  &__file {
    height: calc(100% - 54px);
    width: 100%;
    padding: 14px;
  }
}
</style>
